import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2d70baf0")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")

  return (_openBlock(), _createBlock(_component_el_input, {
    placeholder: _ctx.placeholder,
    modelValue: _ctx.modelValue,
    "show-word-limit": "",
    maxlength: _ctx.maxlength,
    onInput: _ctx.input,
    class: "limit-input",
    ref: "inputRef",
    disabled: _ctx.disabled
  }, null, 8, ["placeholder", "modelValue", "maxlength", "onInput", "disabled"]))
})